import { call, put } from "redux-saga/effects";
import {
    getReseLeakDetectionMonitoringTableData,
    getReseLeakDetectionMonitoringMaterialType,
    getReseLeakDetectionMonitoringDuration,
    postReseLeakDetectionMonitoringInformation,
} from "../components/rese/leak-detection-monitoring/ReseLeakDetectionMonitoringService";
import {
    getReseLeakMonitoringTableDataSuccess,
    getReseLeakMonitoringTableDataError,
    getReseLeakMonitoringMaterialTypeSuccess,
    getReseLeakMonitoringMaterialTypeError,
    getReseLeakMonitoringMaterialDurationSuccess,
    getReseLeakMonitoringMaterialDurationError,
    postReseLeakMonitoringInformationSuccess,
    postReseLeakMonitoringInformationError,
} from "../components/rese/leak-detection-monitoring/redux/actions";

export function* loadReseLeakMonitoringTableData ({ startDatetime, endDatetime, offset }) {
    try {
        const tableData = yield call(getReseLeakDetectionMonitoringTableData, startDatetime, endDatetime, offset);
        yield put(getReseLeakMonitoringTableDataSuccess(tableData));
    } catch (error) {
        yield put(getReseLeakMonitoringTableDataError(error.toString()));
    }
}

export function* loadReseLeakMonitoringMaterialType () {
    try {
        const materialTypes = yield call(getReseLeakDetectionMonitoringMaterialType);
        yield put(getReseLeakMonitoringMaterialTypeSuccess(materialTypes));
    } catch (error) {
        yield put(getReseLeakMonitoringMaterialTypeError(error.toString()));
    }
}

export function* loadReseLeakMonitoringMaterialDuration () {
    try {
        const materialDurations = yield call(getReseLeakDetectionMonitoringDuration);
        yield put(getReseLeakMonitoringMaterialDurationSuccess(materialDurations));
    } catch (error) {
        yield put(getReseLeakMonitoringMaterialDurationError(error.toString()));
    }
}

export function* saveReseLeakMonitoringInformation ({ monitoringInfo }) {
    try {
        const successMessage = yield call(postReseLeakDetectionMonitoringInformation, monitoringInfo);
        yield put(postReseLeakMonitoringInformationSuccess(successMessage));
    } catch (error) {
        yield put(postReseLeakMonitoringInformationError(error.toString()));
    }
}
